import React, { useState } from "react";
import FarmerPlotMappingForm from "./FarmerPlotMappingForm";
import FarmerPlotMappingList from "./FarmerPlotMappingList";

const FarmerPlotMapping = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
  return (
    <>
      {fromIsShown ? (
          <FarmerPlotMappingForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <FarmerPlotMappingList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
};

export default FarmerPlotMapping;
